import {FC} from 'react'
import {useTranslation} from 'react-i18next'
import {Tooltip} from '@components/ui/tooltip/Tooltip.tsx'
import {CheckCircleIcon, Mail01Icon} from '@components/ui/icon/Icon.tsx'
import {StyledInvitationStatusIcon} from '@/features/users/components/invitation-status-icon/style.ts'

interface InvitationStatusIconProps {
    hasAcceptedInvitation: boolean
}

export const InvitationStatusIcon: FC<InvitationStatusIconProps> = ({hasAcceptedInvitation}) => {
    const {t} = useTranslation()

    return (
        <Tooltip
            content={t(
                hasAcceptedInvitation ? 'users:invitation_accepted_tooltip' : 'users:invitation_pending_tooltip'
            )}
            isOpenOnClickEnabled={false}
            triggerProps={{asChild: true}}
        >
            <StyledInvitationStatusIcon $hasAcceptedInvitation={hasAcceptedInvitation}>
                {hasAcceptedInvitation ? <CheckCircleIcon size={16} /> : <Mail01Icon size={16} />}
            </StyledInvitationStatusIcon>
        </Tooltip>
    )
}
